import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { LogosComponent } from "./logoview/logosview";

@NgModule({
    imports: [BrowserModule, SharedModule],
    declarations: [LogosComponent],
    exports: [LogosComponent],
})
export class Common_Logos {}
